<template>
  <div class="lottery-turntable" v-if="cloneComdata.lotteryMode == 'lottery-turntable'">
    <!-- 大转盘 -->
    <div class="turntable ">
      <div class="luckyWheel-frequency">今日剩余抽奖次数：0</div>
      <LuckyWheel
        width="340px"
        height="340px"
        :prizes="prizePool"
        :blocks="blocks"
        :buttons="buttons"
        class="LuckyWheel"
        v-show="!isEdit"
      />
      <img
        class="bottom-img"
        src="https://img3.quanyou.com.cn/joyNew/group1/M00/0B/D0/rB8LrmRbU8KAOFi8AAC9G0jbUVQ388.png"
      />
      </div>
  </div>
  <!-- 九宫格 -->
  <div class="box2"  v-else>
    <div class="com-box">
      <div class="prize-box">
        <div class="prize-item" v-for="(item,index) in prizePool" :key="index">
          <img class="prize-img" :src="item.imgs[0].src" model="widthFix"  alt="" />
          <div class="prize-name">{{item.fonts[0].text}}</div>
        </div>
      </div>
      <div class="btn-box">
        <span class="btn-text">去抽奖</span>
        <span class="number">(剩余0次)</span>
      </div>
      <div class="prize-list">
        <div class="list-head">
          <img src="https://img3.quanyou.com.cn/joyNew/group1/M00/1C/EE/rB8LrWUvmyyASeCKAAACM0Sf2ng753.png" alt="" />
          <span>中奖名单</span>
          <img src="https://img3.quanyou.com.cn/joyNew/group1/M00/1C/EE/rB8LrWUvmyyASeCKAAACM0Sf2ng753.png" alt="" />
        </div>
        <div class="list-item">	当前为预览活动，暂无中奖名单</div>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins],
  data() {
    return {
      blocks: [{ 
        padding: '40px',
        imgs:[{ 
          src: 'https://img3.quanyou.com.cn/joyNew/group1/M00/1E/A2/rB8LrWVBxouAWZywAAJbRwFr2MU982.png',
          width: '375px',
          height: '345px',
          top: '-3px'
        }]
      }],
      buttons: [
        { radius: '37px' },
        { imgs:[{
            src: 'https://img3.quanyou.com.cn/joyNew/group1/M00/19/26/rB8LrWUCyGaAJ14IAAAv3YwRQSk225.png',
            width: '77px',
            height: '79px',
            top: '-55px'
          }]
        }
      ],
    }
  }
}
</script>

<style lang="stylus" scoped>
.box2 {
  width: 100%;
  height: 814px;
  background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1E/9F/rB8LrmVBvQSASTGUAAIDlA1SxPo142.png');
  background-size: 100% 100%;
  overflow hidden;
  .com-box {
    width: 100%;
    height: 664px;
    background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1D/91/rB8LrmU3OVCADQ9GAAH9XSV_AAk951.png');
    background-size: 100% 100%;
    margin-top: 113px;
    overflow hidden
    .prize-box {
      display: flex;
		  flex-flow: wrap;
      width: 286px;
      height: 286px;
      margin: auto;
      margin-top: 95px;
      border-radius: 10px;
      .prize-item{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 95px;
        height: 95px;
        background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1C/FD/rB8LrWUwhveAOv1EAAAfhJDDusA303.png');
        background-size: 100% 100%;
        overflow hidden
        .prize-img {
         	width: 60px;
				  height: 52px;
          margin: 10px 0 4px 0;
        }
        .prize-name {
          color: #914B23;
          font-size: 11px;
          font-weight: bold;
          padding: 0 5px 4px 5px;
          box-sizing: border-box;
          text-align: center;
        }
      }
    }
    .btn-box {
      display: flex;
      justify-content: center;
      width: 202px;
      height: 58px;
      line-height: 48px;
      margin: auto;
      margin-top: 15px;
      background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1C/FC/rB8LrmUwid-AbyA_AACmwA6-q7g382.png');
      background-size: 100% 100%;
      .btn-text {
        color: #9B1824;
        font-size: 18px;
        font-weight: bold; 
      }
      .number {
        color: #9B1824;
        font-size: 14px;
      }
    }
    .prize-list {
      width: 296px;
      height: 126px;
      margin: auto;
      margin-top: 50px;
      border-radius: 10px;
      overflow hidden
      .list-head {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        img {
          width: 14px;
          height: 14px;
        }
        span {
          font-size: 14px;
          color: #fff;
          margin: 0 6px;
        }
      }
      .list-item {
        color: #fff;
        text-align: center;
        margin-top: 20px;
      }
      
    }
  }
}
.lottery-turntable {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 814px;
  background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1E/A2/rB8LrWVBxjyACb7XAAIf5p6UFYs089.png');
  background-size: 100% 100%;
  overflow hidden
  .turntable {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    height: 660px;
    margin-top: 70px;
    background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1E/A3/rB8LrWVBx3uASjHhAAMCUgPrp8w135.png');
    background-size: 100% 100%;
    .luckyWheel-frequency {
      font-size: 13px;
      font-weight: 400;
      color: #FFFFFF;
      margin-top: 59px;
    }
    .LuckyWheel {
      margin-top: 10px;
    }
    .bottom-img {
      width: 180px;
      height: 59px;
      margin-top: 30px;
    }
  }
	
}
</style>